import React from 'react';
import useLocalization from 'localization';
import useTheme from 'branding/theme';
const H = ({ children, role = 'h1', centered = false, inverted = false, noDefaultMargin = false, styles }) => {
    const { t } = useLocalization();
    const { typography } = useTheme();
    const Tag = role;
    const mergedStyles = {
        ...typography.heading[role],
        ...(centered && typography.centered),
        ...(inverted && typography.inverted),
        ...(!noDefaultMargin && typography.defaultMarginBottom),
        ...styles
    };
    return (React.createElement(Tag, { style: mergedStyles }, typeof children === 'string' ? t(String(children)) : children));
};
export default H;
//# sourceMappingURL=index.js.map